import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Recycled water mains (Trunk) - Northern</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          We'll design and construct the recycled water distribution network to bring recycled water from the Fishermans Bend Water Recycling Plant to the Fishermans Bend Precinct. 
        </p>
        <p>
          The Recycled Water Mains will be delivered in two phases, southern and northern. The northern section of the recycled water distribution network runs through the Lorimer, Sandridge, Wirraway, and Employment precincts. 
        </p>
        <p>
          For more project information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/projects/fishermans-bend/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Fishermans Bend - Recycled Water Mains (Trunk)',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800055465">1800 055 465</a> |{' '}
          <a
            href="mailto:FishermansBend@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: FishermansBend@sew.com.au - Fishermans Bend - Recycled Water Mains (Trunk)',
              });
            }}
          >
            FishermansBend@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
